import Hr from 'components/shared/Hr/Hr';
import Icon from 'components/shared/Icon/Icon';

const DefaultReviewComponent = ({ data, navigateToSubstep }) => {
  const formatKey = (key) => {
    return key
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const renderValue = (value) => {
    if (value === null || value === undefined) {
      return '-';
    }
    if (Array.isArray(value)) {
      return value.length > 0 ? 'Created' : 'Not created';
    }
    if (typeof value === 'object') {
      return JSON.stringify(value);
    }
    return String(value);
  };

  return (
    <div>
      {data?.substeps?.map((substep, index) => {
        const isLastSubstep = index === (data?.substeps?.length || 0) - 1;
        return (
          <div key={substep.id}>
            <div className="mb-3 flex items-center gap-2">
              <p className="text-base font-600">{substep.name}</p>
              {substep.status === 'Completed' || substep.status === 'Confirmed' ? (
                <Icon icon="check-linear" color="success" />
              ) : (
                <Icon icon="close-linear" color="danger" />
              )}
              <Icon
                icon="link-linear"
                className="cursor-pointer"
                onClick={() => navigateToSubstep(substep.code)}
              />
            </div>
            {substep.data && (
              <div className="space-y-2">
                {Object.entries(substep.data).map(([key, value]) => {
                  const displayKey = Array.isArray(value) ? 'Status' : formatKey(key);
                  return (
                    <div key={key} className="flex justify-between border-b border-neutral-100">
                      <span className="text-sm font-500 text-neutral-600">{displayKey}</span>
                      <span className="text-sm text-neutral-900">{renderValue(value)}</span>
                    </div>
                  );
                })}
              </div>
            )}
            {!isLastSubstep && <Hr className="my-5" />}
          </div>
        );
      })}
    </div>
  );
};

export default DefaultReviewComponent;
